import { render, staticRenderFns } from "./SubmitToUniversity.vue?vue&type=template&id=e10748ba"
import script from "./SubmitToUniversity.vue?vue&type=script&lang=js"
export * from "./SubmitToUniversity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports